<template>
	<FormSelectbox
		ref="formSelectBoxRef"
		v-bind="$attrs"
		v-model="selected"
		:label-name="labelName"
		:options="options"
		:searchable="false"
		:is-clearable="false"
		:reset-on-options-change="true"
		:max-height="setHeight"
		:error="error"
		:open-top-direction="openTopDirection"
		@click="isViewportTaller"
	/>
</template>

<script setup>
import { ref } from 'vue'
import FormSelectbox from '@/components/selectboxes/FormSelectbox.vue'

const props = defineProps({
	error: {
		type: [String, Boolean],
		default: false,
		required: false,
	},
	labelName: {
		type: String,
		default: 'Select a state',
		required: false,
	},
	options: {
		type: Array,
		default: () => [
			{ value: 'ACT', label: 'Australian Capital Territory (ACT)' },
			{ value: 'NSW', label: 'New South Wales (NSW)' },
			{ value: 'NT', label: 'Northern Territory (NT)' },
			{ value: 'QLD', label: 'Queensland (QLD)' },
			{ value: 'SA', label: 'South Australia (SA)' },
			{ value: 'TAS', label: 'Tasmania (TAS)' },
			{ value: 'VIC', label: 'Victoria (VIC)' },
			{ value: 'WA', label: 'Western Australia (WA)' },
		],
		required: false,
	},
	showError: {
		type: Boolean,
		default: true,
		required: false,
	},
	openTopDirection: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const formSelectBoxRef = ref()

const setHeight = ref('h-fit')

const selected = ref()

const reset = () => {
	formSelectBoxRef.value.reset()
}

defineExpose({ reset })

const isViewportTaller = () => {
	if (import.meta.client) {
		const isWindowHeightAbove = window.innerHeight > 700

		if (props.openTopDirection) {
			setHeight.value = 'h-fit'
		} else if (isWindowHeightAbove) {
			setHeight.value = 'h-fit'
		} else {
			setHeight.value = 'max-h-40'
		}
	}
}
</script>
